import { EuiButtonProps } from "@inscopix/ideas-eui";
import { ButtonEmptyPermissioned } from "components/ButtonEmptyPermissioned/ButtonEmptyPermissioned";
import { useUploadFile } from "hooks/useUploadFile";
import { useProjectDataContext } from "pages/project/ProjectDataProvider";
import { useTourStep } from "providers/TourProvider/TourProvider.hooks";
import { DRS_FILE_ACTION_ICONS } from "types/Icons";
import { addUtilityToastFailure } from "utils/addUtilityToastFailure";
import { addUtilityToastSuccess } from "utils/addUtilityToastSuccess";
import { selectSystemFiles } from "utils/selectSystemFiles";
import { uuid } from "utils/uuid";

export type ButtonProjectUploadProps = Omit<EuiButtonProps, "onClick">;

export const ButtonProjectUpload = (props: ButtonProjectUploadProps) => {
  const { project } = useProjectDataContext();
  const { writeCache, enqueueUpload } = useUploadFile();

  const handleUpload = (files: File[]) => {
    files.forEach((file) => {
      const dateCreated = new Date().toISOString();
      const fileId = uuid();

      const params = {
        id: fileId,
        dateCreated,
        name: file.name,
        project,
        tenantId: project.tenantId,
        size: String(file.size),
      };

      enqueueUpload({ ...params, blob: file })
        .then(() => {
          writeCache(params);
        })
        .catch(() => {
          addUtilityToastFailure(`Failed to upload ${file.name}`);
        });
    });
    addUtilityToastSuccess(
      `Successfully queued ${files.length} files for upload.`,
    );
  };

  /* Tours */

  const { component: TourDataTableUploadFiles1, anchorId } = useTourStep(
    "TourDataTableUploadFiles",
    1,
  );

  return (
    <>
      <ButtonEmptyPermissioned
        onClick={() =>
          void selectSystemFiles(true).then((files) => {
            if (files !== undefined) {
              handleUpload(files);
            }
          })
        }
        {...props}
        requiredPermission="upload"
        iconType={DRS_FILE_ACTION_ICONS.upload}
        id={anchorId}
      >
        Upload
      </ButtonEmptyPermissioned>
      {TourDataTableUploadFiles1}
    </>
  );
};
